const th = {
  meta: { title: "Trollfossjakten · The Troll Waterfall Quest — โทรลล์ 84 ตัว ระหว่าง Lavangen และ Årstein" },
  sound: { mute: "ปิดเสียงโทรลล์", unmute: "เปิดเสียงโทรลล์" },
  nav: { map: "แผนที่", trolls: "โทรลล์", seasons: "ฤดูกาล", pricing: "ราคา", faq: "คำถามที่พบบ่อย", getApp: "ดาวน์โหลดแอป", hosts: "เป็นเจ้าบ้าน" },
  tagline: "โทรลล์ 61 ตัวเล่นฟรีตลอดไป ที่เหลือยังซ่อนตัวอยู่ — อย่าลืมพกพาสมาด้วย",
  store: { soon: "แอปใกล้จะออกจากป่าแล้ว", soonBody: "ลิงก์สโตร์จะเปิดใช้งานในวันเปิดตัว — แวะกลับมาเร็ว ๆ นี้นะ", appStore: "App Store", playStore: "Google Play", download: "ดาวน์โหลดบน", getIt: "รับได้ที่" },
  hero: {
    kicker: "Lavangen · Gratangen · Troms",
    title: "ตามล่าโทรลล์ 84 ตัว ระหว่าง Lavangen และ Årstein",
    pitch: "น้ำตก 9 แห่ง โทรลล์ทำมือ 84 ตัว และถนนเลียบฟยอร์ดหนึ่งสาย เริ่มเล่นได้ฟรี — ฤดูหนาวเล่นบนสกี ฤดูร้อนเล่นบนสเก็ต",
    cta: "เริ่มภารกิจ",
    ctaMap: "ดูแผนที่ทั้งหมด",
    stats: [["84", "โทรลล์"], ["9", "น้ำตก"], ["61", "ฟรีตลอดไป"], ["4", "ฤดูกาล"]],
    stamp: "เริ่มเล่นฟรี",
    photoNote: "น้ำตก · ฟยอร์ด · โทรลล์",
  },
  what: {
    kicker: "Trollfossjakten คืออะไร?",
    title: "ล่าสมบัติจากนิทานพื้นบ้าน บนถนนเลียบฟยอร์ดของจริง",
    cols: [
      { title: "เดินตามเส้นทาง", body: "ไปตามถนนจาก Lavangen ถึง Årstein จะเดิน ปั่นจักรยาน เล่นสกี หรือสเก็ตก็ได้ มีน้ำตกเก้าแห่งคอยบอกทาง" },
      { title: "จับโทรลล์", body: "โทรลล์ทำมือ 84 ตัวซ่อนอยู่ริมลำธาร ชายฝั่ง และร้านค้า ตามหา จับให้ได้ แล้วเติมสมุดบันทึกของคุณให้เต็ม" },
      { title: "สะสมโครนโทรลล์", body: "เก็บสกุลเงินในแอป แล้วนำไปใช้ที่กระท่อม คาเฟ่ และร้านค้าพันธมิตรตลอดเส้นทาง" },
    ],
    callout: "ไม่ต้องสมัครสมาชิก เปิดแอปแล้วเริ่มล่าได้เลย",
  },
  map: {
    kicker: "แผนที่เส้นทาง",
    title: "ปักหมุดโทรลล์ไว้ทุกตัว",
    body: "โทรลล์ 84 ตัวกระจายอยู่ตามถนนจาก Lavangen ถึง Årstein ผ่าน Røkenes, Hestnes และ Sørsida แตะหมุดเพื่อทำความรู้จัก — แล้วไปจับตัวจริงในแอป",
    chips: { all: "ทั้งหมด", common: "ธรรมดา", rare: "หายาก", epic: "มหากาพย์", legendary: "ตำนาน", festivals: "เทศกาล", merchants: "พ่อค้า" },
    showing: "ตัวที่แสดงอยู่",
    start: "Lavangen · จุดเริ่มต้น",
    finish: "Årstein · เส้นชัย",
    waterfall: "น้ำตก",
    catchIt: "จับมันในแอป",
    close: "ปิด",
    recenter: "กลับไปที่เส้นทาง",
  },
  xp: {
    kicker: "XP และระบบเกม",
    title: "ล่า เลเวลอัป แล้วอวดนิดหน่อย",
    body: "จับได้ทุกครั้งรับ XP โทรลล์ยิ่งหายากยิ่งได้มาก — และบางตัวจะโผล่มาเฉพาะวันที่ปฏิทินกำหนดเท่านั้น",
    cards: {
      xp: { title: "XP ตามระดับความหายาก", body: "ยิ่งซ่อนเก่ง ยิ่งให้รางวัลมาก" },
      ach: { title: "ความสำเร็จ 12 รายการ", body: "สูงสุดรายการละ 5 000 XP ตัวอย่างบางส่วน:", more: "+ อีก 6 รายการให้ค้นพบในแอป" },
      items: { title: "ไอเทมและชุดสะสม", body: "เก็บของจุกจิกที่โทรลล์ทิ้งไว้ แล้วสะสมให้ครบชุด", list: ["ไข่มุก", "อักษรรูน", "วาฟเฟิล", "ทองโจรสลัด"] },
      kroner: { title: "โครนโทรลล์", body: "ได้จากการชวนเพื่อน วงล้อนำโชครายวัน และโทรลล์พ่อค้า ใช้จ่ายได้ที่กระท่อมและร้านค้าพันธมิตร" },
    },
    achievements: [["จับตัวแรก", 20], ["แฟนเทศกาล", 500], ["ราชาแห่งลำธาร", 800], ["นักรบผู้โดดเดี่ยว", 1000], ["นักล่าในตำนาน", 1500], ["ครบรอบสี่ฤดู", 5000]],
    extras: [
      { title: "สตรีค + โล่สตรีค", body: "ล่าทุกวันเพื่อเพิ่มสตรีค โล่ช่วยรักษาสตรีคได้หนึ่งวันที่พลาดต่อสัปดาห์" },
      { title: "วงล้อนำโชครายวัน", body: "รูเล็ตถ่วงน้ำหนัก 3 ระดับ หมุนได้หนึ่งครั้งทุก 24 ชั่วโมง" },
      { title: "พาส", body: "Epic Pass หรือ Rare Pass ใช้ได้ 365 วันนับจากวันเปิดใช้งาน มีแบบรายบุคคล ครอบครัว ทีม และกลุ่มรถบัส" },
      { title: "โทรลล์พิเศษ", body: "โทรลล์เฉพาะสุดสัปดาห์ 2 ตัว (ศุกร์–อาทิตย์) โทรลล์เฉพาะเทศกาล 10 ตัว โทรลล์พ่อค้า 6 ตัวที่ร้านค้าท้องถิ่น และโทรลล์โปรโมชัน 5 ตัว" },
    ],
  },
  gallery: {
    kicker: "สมุดบันทึกโทรลล์",
    title: "พบกับโทรลล์ทั้ง 84 ตัว",
    body: "โทรลล์ทุกตัวมีชื่อ ฉายา และนิสัยประจำตัว แตะการ์ดเพื่ออ่านบันทึกของมัน",
    chips: { all: "ทั้งหมด", common: "ธรรมดา", rare: "หายาก", epic: "มหากาพย์", legendary: "ตำนาน", festivals: "เทศกาล", merchants: "พ่อค้า", weekend: "สุดสัปดาห์", promo: "โปรโมชัน" },
    more: "แสดงโทรลล์เพิ่มเติม",
    count: "จาก 84",
    portraitNote: "ที่เหลือยังซ่อนตัวอยู่ — ไปตามหาในแอปสิ",
    hidden: "ยังซ่อนตัวอยู่",
    hiding: "ซ่อนตัว",
  },
  journal: {
    entry: "บันทึกประจำตัว",
    where: "ที่อยู่",
    waterfall: "น้ำตก",
    xp: "XP",
    access: "ปลดล็อก",
    window: "ปรากฏตัว",
    weekend: "เฉพาะวันศุกร์ถึงวันอาทิตย์",
    liveNow: "ออกมาแล้วตอนนี้",
    catchIt: "จับมันในแอป",
  },
  access: { free: "ฟรีตลอดไป", epic_pass: "Epic Pass", rare_pass: "Rare Pass" },
  rarity: { common: "ธรรมดา", rare: "หายาก", epic: "มหากาพย์", legendary: "ตำนาน" },
  category: { stream: "โทรลล์ลำธาร", intro: "ไกด์นำทาง", merchant: "โทรลล์พ่อค้า", promo: "โทรลล์โปรโมชัน", weekend: "โทรลล์สุดสัปดาห์", festival_sami: "โทรลล์เทศกาลซามี", festival_norwegian: "โทรลล์เทศกาลนอร์เวย์" },
  specials: {
    kicker: "โทรลล์พิเศษ",
    title: "โทรลล์พิเศษ 19 ตัว — แถมโทรลล์โปรโมชันอีก 5 ตัว",
    body: "โทรลล์บางตัวมีปฏิทินของตัวเอง โทรลล์เทศกาลจะปรากฏเฉพาะในวันจัดเทศกาลจริงเท่านั้น",
    flavours: [
      { key: "intro", count: 1, title: "ไกด์นำทาง", body: "โทรลล์ตัวแรกของคุณที่ Lavangen — จะพาคุณรู้จักวิธีล่า" },
      { key: "festival_sami", count: 4, title: "โทรลล์เทศกาลซามี", body: "วันชาติซามี, Riddu Riđđu และ Márkomeannu" },
      { key: "festival_norwegian", count: 6, title: "โทรลล์เทศกาลนอร์เวย์", body: "ตั้งแต่วันที่ 17 พฤษภาคมไปจนถึงราตรีขั้วโลก" },
      { key: "weekend", count: 2, title: "โทรลล์สุดสัปดาห์", body: "ออกมาเฉพาะวันศุกร์ถึงวันอาทิตย์" },
      { key: "merchant", count: 6, title: "โทรลล์พ่อค้า", body: "อาศัยอยู่ที่ร้านค้าท้องถิ่นของจริงบนเส้นทาง" },
      { key: "promo", count: 5, title: "โทรลล์โปรโมชัน", body: "ปลดล็อกได้ด้วยการชวนเพื่อน โปสเตอร์ และโค้ดโปรโมชัน" },
    ],
    calendar: "ปฏิทินเทศกาล",
    next: "ช่วงถัดไป",
    liveNow: "ออกมาแล้วตอนนี้",
  },
  festivals: {
    "Sámi National Day": "วันชาติซามี", "Riddu Riđđu": "Riddu Riđđu", "Márkomeannu": "Márkomeannu",
    "Constitution Day": "วันรัฐธรรมนูญ", "Midsummer": "เทศกาลกลางฤดูร้อน", "Lussinatta": "คืนลุสซี",
    "Christmas": "คริสต์มาส", "Midnight Sun": "พระอาทิตย์เที่ยงคืน", "Polar Night": "ราตรีขั้วโลก",
  },
  seasons: {
    kicker: "สี่ฤดูกาล",
    title: "เส้นทางเดียว สี่บรรยากาศที่แตกต่างสุดขั้ว",
    standout: "โทรลล์เด่นประจำฤดู",
    tabs: {
      winter: { name: "ฤดูหนาว", title: "เล่นสกีใต้แสงออโรรา", body: "ไถลไปตามเส้นทางด้วยสกีทางเรียบ ขณะที่แสงเหนือร่ายรำเหนือฟยอร์ด สวมไฟฉายคาดหัว เติมกระติกน้ำร้อนให้เต็ม" },
      spring: { name: "ฤดูใบไม้ผลิ", title: "อีสเตอร์กับเรนเดียร์", body: "วันยาวและสว่าง หิมะกรอบ ๆ และฝูงเรนเดียร์ที่กำลังย้ายถิ่น เหมาะกับครอบครัวในช่วงเส้นทางที่ไม่ชัน" },
      summer: { name: "ฤดูร้อน", title: "กองไฟใต้พระอาทิตย์เที่ยงคืน", body: "เล่นโรลเลอร์เบลดบนช่วงถนนเรียบ ปล่อยให้เด็ก ๆ ปั่นจักรยานนำหน้า แล้วจุดกองไฟเมื่อพระอาทิตย์ไม่ยอมตก" },
      autumn: { name: "ฤดูใบไม้ร่วง", title: "เดินป่าเก็บเห็ด", body: "ต้นเบิร์ชสีทอง บลูเบอร์รี และเห็ดแชนเทอเรล ปู่ย่าตายายชอบช่วงทางที่ไม่ชัน — โทรลล์ก็ชอบเหมือนกัน" },
    },
  },
  merchants: {
    kicker: "ธุรกิจท้องถิ่น",
    title: "โทรลล์พ่อค้าอาศัยอยู่ที่ร้านท้องถิ่นของจริง",
    body: "โทรลล์หกตัวอาศัยอยู่ที่กระท่อม คาเฟ่ ร้านค้า และร้านให้เช่าตลอดเส้นทาง ตามหาได้ฟรี แล้วใช้โครนโทรลล์ได้ที่นั่น",
    partnerSoon: "เปิดเผยชื่อพันธมิตรในวันเปิดตัว",
    spend: "ใช้โครนโทรลล์ได้ที่นี่",
    types: { "Cabin rental": "กระท่อมให้เช่า", "Farm shop": "ร้านค้าฟาร์ม", "Café": "คาเฟ่", "Kayak rental": "เรือคายัคให้เช่า", "Bakery": "ร้านเบเกอรี่", "Grocer · finish line": "ร้านขายของชำ · เส้นชัย" },
  },
  pricing: {
    kicker: "ราคา",
    title: "เริ่มฟรี แล้วใช้พาสปลดล็อกที่เหลือ",
    launch: "ราคาเปิดตัว · ลด 50% ตลอดฤดูกาล 2026",
    tiers: { person: "บุคคล", family: "ครอบครัว", team: "ทีม", bus: "กลุ่มรถบัส" },
    days: "365 วันนับจากวันเปิดใช้งาน",
    free: { name: "ฟรี", price: "0 kr", line: "โทรลล์ 61 ตัวฟรีตลอดไป", body: "ไม่ต้องสมัครสมาชิก", perks: ["โทรลล์ลำธารระดับธรรมดาและหายากทุกตัว", "โทรลล์พ่อค้าทั้ง 6 ตัว", "ไกด์นำทาง + โทรลล์โปรโมชัน 5 ตัว"], cta: "เริ่มฟรี" },
    epic: { name: "Epic Pass", line: "ปลดล็อกโทรลล์ระดับมหากาพย์ + ตำนาน", perks: ["โทรลล์ลำธารระดับมหากาพย์และตำนานทุกตัว", "โทรลล์สุดสัปดาห์ทั้งสองตัว"], cta: "ซื้อ Epic Pass" },
    rare: { name: "Rare Pass", line: "ปลดล็อกโทรลล์ทุกตัว — รวมโทรลล์เทศกาลและตำนาน", perks: ["โทรลล์ทั้ง 84 ตัว", "โทรลล์เทศกาลทั้ง 10 ตัว", "ทุกอย่างใน Epic Pass"], cta: "ซื้อ Rare Pass", ribbon: "โทรลล์ทั้ง 84 ตัว" },
    note: "ซื้อพาสได้ในแอป ราคาเปิดตัวมีเวลาจำกัด",
    was: "ราคาเดิม",
  },
  faq: {
    kicker: "คำถามที่พบบ่อย",
    title: "คำถามจากจุดเริ่มต้นเส้นทาง",
    items: [
      ["ต้องสมัครสมาชิกไหม?", "ไม่ต้อง ดาวน์โหลดแอป เปิดขึ้นมา แล้วเริ่มล่าได้เลย โทรลล์ 61 ตัวเล่นฟรีตลอดไป"],
      ["บนเส้นทางมีสัญญาณมือถือไหม?", "ตลอดถนนโดยทั่วไปสัญญาณดี แต่อาจขาดหายบ้างในบางจุดของหุบเขา ชาร์จโทรศัพท์ให้เต็มและจดเบอร์ฉุกเฉินไว้ก่อนออกเดินทาง"],
      ["เล่นในฤดูหนาวได้ไหม?", "ได้ โทรลล์ออกมาตลอดทั้งปี เตรียมสกีหรือแผ่นกันลื่น ไฟฉายคาดหัวสำหรับช่วงราตรีขั้วโลก และตรวจสอบสภาพถนนก่อนออกเดินทาง"],
      ["เหมาะกับเด็กไหม?", "เหมาะมาก โทรลล์หลายตัวอยู่ใกล้ถนน และช่วงทางที่ไม่ชันก็เหมาะกับขาเล็ก ๆ จักรยาน และรถเข็นเด็ก บางช่วงของเส้นทางเป็นถนนสาธารณะ จึงควรระวังรถด้วย"],
      ["จอดรถที่ไหน และจะกลับอย่างไร?", "เริ่มต้นที่ Lavangen หรือ Årstein มีรถบัสประจำทางวิ่งผ่านบางช่วงของเส้นทาง — ตรวจสอบตารางเวลาท้องถิ่นก่อนออกเดินทาง"],
      ["โทรลล์พ่อค้าคืออะไร?", "โทรลล์ที่อาศัยอยู่ในธุรกิจท้องถิ่นของจริงบนเส้นทาง เช่น กระท่อม คาเฟ่ หรือร้านค้า จับได้ฟรี และคุณใช้โครนโทรลล์ที่นั่นได้"],
      ["โครนโทรลล์คืออะไร?", "สกุลเงินในแอป ได้จากการชวนเพื่อน วงล้อนำโชครายวัน และโทรลล์พ่อค้า แล้วนำไปใช้ที่กระท่อมและร้านค้าพันธมิตร"],
      ["วันจัดเทศกาลแม่นยำแค่ไหน?", "โทรลล์เทศกาลจะปรากฏเฉพาะในช่วงวันจัดเทศกาลจริงเท่านั้น หากเทศกาลเลื่อนวัน โทรลล์ก็เลื่อนตามไปด้วย"],
      ["พาสใช้ได้นานแค่ไหน?", "Epic Pass และ Rare Pass ใช้ได้ 365 วันนับจากวันที่คุณเปิดใช้งาน มีแบบรายบุคคล ครอบครัว ทีม และกลุ่มรถบัส"],
      ["แล้วความเป็นส่วนตัวของฉันล่ะ?", "คุณเล่นได้โดยไม่ต้องมีบัญชี แอปใช้ตำแหน่งของคุณเพื่อแสดงโทรลล์ที่อยู่ใกล้ระหว่างเล่น ส่วนเว็บไซต์นี้ไม่ขอข้อมูลใดจากคุณเลย"],
    ],
  },
  install: { title: "Trollfossjakten", body: "โทรลล์ 61 ตัวฟรีตลอดไป", cta: "ดาวน์โหลดแอป", dismiss: "ปิดแถบติดตั้ง" },
  footer: { supporter: "ร่วมเป็นผู้สนับสนุน", about: "เกี่ยวกับเรา", press: "สื่อมวลชน", privacy: "ความเป็นส่วนตัว", terms: "ข้อกำหนด", contact: "ติดต่อ", follow: "ติดตามการล่า", soon: "พร้อมในวันเปิดตัว", country: "นอร์เวย์", supportedBy: "สนับสนุนโดย" },
  logoAlt: "โลโก้ Trollfossjakten",
  langSwitch: "ภาษา",
  a11y: { menu: "เมนู", footer: "ส่วนท้าย", zoomIn: "ซูมเข้า", zoomOut: "ซูมออก", notifications: "การแจ้งเตือน" },
  sos: "ข้อมูลฉุกเฉิน",
  emergency: {
    back: "กลับ",
    title: "เหตุฉุกเฉิน",
    alert: "หากคุณตกอยู่ในอันตราย ให้โทรหาหมายเลขฉุกเฉินในพื้นที่ทันที",
    h1: "SOS — ความช่วยเหลือด่วน ทุกที่บนเส้นทาง",
    intro: "แตะหมายเลขเพื่อโทร แชร์ตำแหน่งปัจจุบันของคุณ พร้อมรูปภาพและข้อความ (ไม่บังคับ) ให้ครอบครัว เพื่อน หรือหน่วยกู้ภัย",
    step: "ขั้นตอนที่ {n}",
    country: "ประเทศของคุณ",
    search: "ค้นหาประเทศ…",
    noMatch: "ไม่พบประเทศที่ตรงกัน",
    callNow: "โทรเลย —",
    all: "เหตุฉุกเฉินทุกประเภท",
    police: "ตำรวจ",
    fire: "ดับเพลิง",
    ambulance: "รถพยาบาล",
    locTitle: "ส่งตำแหน่งปัจจุบันของคุณ",
    detect: "ระบุตำแหน่งของฉัน",
    locating: "กำลังระบุตำแหน่ง…",
    refresh: "รีเฟรชตำแหน่ง",
    noGeo: "เบราว์เซอร์ของคุณไม่รองรับการระบุตำแหน่ง",
    locFail: "ไม่สามารถระบุตำแหน่งของคุณได้",
    near: "ใกล้",
    openMaps: "เปิดใน Google Maps ↗",
    msgLabel: "เพิ่มข้อความ (ไม่บังคับ)",
    msgPh: "เช่น ข้อเท้าพลิกใกล้น้ำตกแห่งที่สอง ช่วยนำน้ำและชุดปฐมพยาบาลมาด้วย",
    photoLabel: "แนบรูปภาพ (ไม่บังคับ)",
    choose: "เลือกรูปภาพ",
    change: "เปลี่ยนรูปภาพ",
    remove: "ลบ",
    previewAlt: "รูปภาพที่แนบ",
    send: "ส่งตำแหน่งฉุกเฉิน",
    copy: "คัดลอก",
    shared: "แชร์จากอุปกรณ์ของคุณแล้ว",
    shareFail: "ไม่สามารถเปิดเมนูแชร์ได้ ลองใช้ปุ่มคัดลอกแทน",
    copied: "คัดลอกแล้ว",
    copyFail: "คัดลอกไม่สำเร็จ",
    privacy: "การแชร์ใช้เมนูแชร์ของโทรศัพท์คุณเอง (SMS, WhatsApp, อีเมล ฯลฯ) ไม่มีข้อมูลใดถูกส่งผ่านเซิร์ฟเวอร์ของเรา ในเหตุฉุกเฉินจริง โปรดโทรหาหมายเลขด้านบนด้วยเสมอ",
    backTrail: "กลับสู่เส้นทาง",
    msgHead: "🆘 ฉุกเฉิน — ฉันต้องการความช่วยเหลือ",
    mapLabel: "แผนที่",
    timeLabel: "เวลา",
    shareTitle: "เหตุฉุกเฉิน — Trollfossjakten",
    notes: {
      NO: "112 คือหมายเลขฉุกเฉินของยุโรป 110 ติดต่อหน่วยดับเพลิง และ 113 ติดต่อหน่วยแพทย์โดยตรง",
      SE: "หมายเลขฉุกเฉินเดียว 112 สำหรับทุกหน่วยงาน",
      FI: "112 ติดต่อได้ทั้งตำรวจ ดับเพลิง และรถพยาบาล",
      DK: "112 สำหรับเหตุฉุกเฉิน 114 สำหรับแจ้งตำรวจกรณีไม่เร่งด่วน",
      IS: "หมายเลขเดียวทั่วประเทศ: 112",
      DE: "110 สำหรับตำรวจ 112 สำหรับดับเพลิงและรถพยาบาล",
      FR: "17 ตำรวจ 18 ดับเพลิง 15 รถพยาบาล (SAMU) ใช้ 112 ได้เช่นกัน",
      GB: "999 (หรือ 112) สำหรับเหตุฉุกเฉินทุกประเภท 101 สำหรับแจ้งตำรวจกรณีไม่เร่งด่วน",
      IE: "ใช้ได้ทั้ง 112 และ 999",
      NL: "112 สำหรับเหตุฉุกเฉิน 0900-8844 สำหรับแจ้งตำรวจกรณีไม่เร่งด่วน",
      ES: "112 ครอบคลุมทุกหน่วยงาน ตำรวจแห่งชาติ 091 ตำรวจท้องถิ่น 092",
      IT: "112 สำหรับเหตุฉุกเฉินทุกประเภท 113 ตำรวจรัฐ",
      PL: "112 ติดต่อได้ทุกหน่วยงาน",
      US: "โทร 911 สำหรับเหตุฉุกเฉินทุกประเภท หลายเมืองใช้ 311 สำหรับเรื่องไม่ฉุกเฉิน",
      CA: "911 ทั่วประเทศสำหรับเหตุฉุกเฉินทุกประเภท",
      AU: "Triple Zero (000) และใช้ 112 ได้เช่นกันบนโทรศัพท์มือถือ",
      NZ: "111 ทั่วประเทศ 105 สำหรับแจ้งตำรวจกรณีไม่เร่งด่วน",
      CN: "110 ตำรวจ 119 ดับเพลิง 120 รถพยาบาล 122 อุบัติเหตุจราจร",
      RU: "112 ติดต่อได้ทุกหน่วยงาน 102 ตำรวจ 101 ดับเพลิง 103 รถพยาบาล",
      TH: "191 ตำรวจ 199 ดับเพลิง 1669 การแพทย์ฉุกเฉิน ตำรวจท่องเที่ยว 1155 (พูดภาษาอังกฤษได้)",
    },
  },
};

export default th;
